import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "../data/menu";

export const Testimonials = () => {
  return (
    <section className="relative py-20 sm:py-28 bg-[#2D2327] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <p className="font-script text-[#FFD166] text-3xl -rotate-2 inline-block">people say,</p>
            <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-white tracking-tight mt-2">
              Sweet on the <span className="italic text-[#FF8FB1]">Valley.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 text-sm text-white/70">
            <Star className="h-4 w-4 fill-[#FFD166] text-[#FFD166]" />
            4.8 average · 119+ public ratings
          </div>
        </div>
      </div>

      <Marquee gradient gradientColor="#2D2327" speed={32} pauseOnHover>
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            data-testid={`testimonial-${i}`}
            className="mx-3 sm:mx-4 w-[280px] sm:w-[380px] shrink-0 rounded-3xl bg-white/5 backdrop-blur border border-white/10 p-6 sm:p-7"
          >
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: t.rating }).map((_, idx) => (
                <Star key={idx} className="h-4 w-4 fill-[#FFD166] text-[#FFD166]" />
              ))}
            </div>
            <p className="font-serif-display text-xl sm:text-2xl text-white leading-snug">&ldquo;{t.text}&rdquo;</p>
            <div className="mt-6 flex items-center justify-between text-sm text-white/70">
              <span className="font-semibold text-white">{t.name}</span>
              <span className="uppercase tracking-[0.18em] text-xs">{t.source}</span>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default Testimonials;
